/**
 * Archive formations — sous-filtres catégorie + modale filtres mobile.
 */
export class Archive {
  constructor() {
    this.root = document.querySelector('.s-formation-archive')
    if (!this.root) {
      return
    }

    this.parents = [...this.root.querySelectorAll('[data-category-parent]')]
    this.modal = this.root.querySelector('[data-formation-filter-modal]')
    this.openBtn = this.root.querySelector('[data-formation-filter-open]')
    this.dialog = this.modal?.querySelector('.s-formation-archive__modal-dialog')
    this.mq = window.matchMedia(`(max-width: 769px)`)

    this.parents.forEach((input) => {
      input.addEventListener('change', () => this.syncChildGroups(input))
    })
    if (this.parents.length) {
      this.syncChildGroups()
    }

    this.bindFilterModal()
  }

  /**
   * @param {HTMLInputElement|null} changedParent
   */
  syncChildGroups(changedParent = null) {
    this.root.querySelectorAll('[data-category-children-for]').forEach((fieldset) => {
      const slug = fieldset.getAttribute('data-category-children-for')
      const parent = this.parents.find((input) => input.getAttribute('data-category-parent') === slug)
      const childInputs = [...fieldset.querySelectorAll('input[type="checkbox"]')]
      const parentChecked = Boolean(parent?.checked)

      // ponytail: décocher les enfants dès que le parent est décoché
      if (changedParent && parent === changedParent && !parentChecked) {
        childInputs.forEach((input) => {
          input.checked = false
        })
      }

      const hasCheckedChild = childInputs.some((input) => input.checked)
      fieldset.hidden = !(parentChecked || hasCheckedChild)
    })
  }

  bindFilterModal() {
    if (!this.modal || !this.openBtn) {
      return
    }

    this.syncModalMode()
    this.mq.addEventListener('change', () => this.syncModalMode())

    this.openBtn.addEventListener('click', () => this.openFilterModal())

    this.modal.querySelectorAll('[data-formation-filter-close]').forEach((el) => {
      el.addEventListener('click', () => this.closeFilterModal())
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.closeFilterModal()
      }
    })
  }

  syncModalMode() {
    if (!this.mq.matches) {
      this.closeFilterModal()
      this.modal.inert = false
      return
    }

    if (!this.modal.classList.contains('is-open')) {
      this.modal.inert = true
    }
  }

  openFilterModal() {
    if (!this.mq.matches) {
      return
    }

    this.modal.inert = false
    this.modal.classList.add('is-open')
    this.openBtn.setAttribute('aria-expanded', 'true')
    this.dialog?.setAttribute('role', 'dialog')
    this.dialog?.setAttribute('aria-modal', 'true')
    this.dialog?.setAttribute('aria-labelledby', 'formation-filters-title')
    document.body.classList.add('formation-filters-modal-open')
    this.modal.querySelector('.s-formation-archive__modal-close')?.focus()
  }

  closeFilterModal() {
    if (!this.modal.classList.contains('is-open')) {
      if (this.mq.matches) {
        this.modal.inert = true
      }
      return
    }

    this.modal.classList.remove('is-open')
    this.openBtn.setAttribute('aria-expanded', 'false')
    this.dialog?.removeAttribute('role')
    this.dialog?.removeAttribute('aria-modal')
    this.dialog?.removeAttribute('aria-labelledby')
    document.body.classList.remove('formation-filters-modal-open')

    if (this.mq.matches) {
      this.modal.inert = true
      this.openBtn.focus()
    }
  }
}
